import clsx from "clsx";
import {
  normalizeSearchScope,
  type SearchScope,
} from "@/features/search/searchScope";

interface SearchScopeSelectProps {
  ariaLabel: string;
  className?: string;
  onChange: (scope: SearchScope) => void;
  scope: SearchScope;
}

/** 検索窓の隣で、公開返信を含む全文かスレ文だけかを選ぶ。 */
export function SearchScopeSelect({
  ariaLabel,
  className,
  onChange,
  scope,
}: SearchScopeSelectProps): React.ReactElement {
  return (
    <select
      aria-label={ariaLabel}
      value={scope}
      onChange={(event: React.ChangeEvent<HTMLSelectElement>): void =>
        onChange(normalizeSearchScope(event.currentTarget.value))
      }
      className={clsx(
        "search-scope-select h-11 w-28 shrink-0 rounded-lg border border-border bg-muted px-2 text-sm text-foreground focus:border-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary",
        className,
      )}
    >
      <option value="all">全文</option>
      <option value="op">スレ文</option>
    </select>
  );
}
